import React from 'react';
import { CheckCircle2, FileText, Calendar, MessageSquare, Smartphone } from 'lucide-react';
export function DeliverablesSection() {
  const items = [{
    icon: FileText,
    title: 'La guía completa Doble Control 4×4',
    desc: 'El manual paso a paso sin relleno teórico.'
  }, {
    icon: CheckCircle2,
    title: 'Sistema de Sobres Simplificado',
    desc: 'Cómo armar tus 4 sobres sin crear 20 categorías confusas.'
  }, {
    icon: Smartphone,
    title: 'Estrategia Anti-Yape/Plin',
    desc: "Cómo crear tus 4 topes digitales para no 'evaporarte'."
  }, {
    icon: Calendar,
    title: 'Plan de Implementación de 14 días',
    desc: 'Qué hacer exactamente cada día para tomar el control.'
  }, {
    icon: MessageSquare,
    title: "Guiones para decir 'NO'",
    desc: 'Plantillas para poner límites a la familia sin pelear.'
  }];
  return <section className="py-10 px-4 bg-[#fffbf0]" data-id="element-21">
      <div className="max-w-4xl mx-auto" data-id="element-22">
        <h2 className="text-2xl font-bold text-[#1e3a5f] mb-8 text-center" data-id="element-23">
          Qué obtienes (sin humo)
        </h2>

        <div className="bg-white p-6 rounded-2xl shadow-lg border border-stone-100" data-id="element-24">
          <div className="grid md:grid-cols-2 gap-6" data-id="element-25">
            <div className="space-y-4" data-id="element-26">
              {items.map((item, idx) => <div key={idx} className="flex items-start" data-id="element-27">
                  <item.icon className="h-5 w-5 text-[#e63946] mr-3 mt-0.5 flex-shrink-0" data-id="element-28" />
                  <div data-id="element-29">
                    <h3 className="font-bold text-slate-800 text-sm" data-id="element-30">
                      {item.title}
                    </h3>
                    <p className="text-xs text-slate-600" data-id="element-31">{item.desc}</p>
                  </div>
                </div>)}
            </div>

            <div className="bg-stone-50 p-4 rounded-xl border border-stone-200" data-id="element-32">
              <h3 className="font-bold text-[#1e3a5f] mb-3 flex items-center text-sm" data-id="element-33">
                <span className="bg-[#1e3a5f] text-white text-xs px-2 py-0.5 rounded mr-2" data-id="element-34">
                  BONUS
                </span>
                Plantillas Imprimibles
              </h3>
              <ul className="space-y-2" data-id="element-35">
                {['Etiquetas para sobres', 'Tracker semanal visual', 'Filtro anti-impulso de compra'].map((bonus, idx) => <li key={idx} className="flex items-center text-slate-700 text-xs" data-id="element-36">
                    <div className="h-1 w-1 rounded-full bg-[#e63946] mr-2" data-id="element-37"></div>
                    {bonus}
                  </li>)}
              </ul>
              <div className="mt-4 pt-4 border-t border-stone-200 text-center" data-id="element-38">
                <p className="text-slate-500 text-xs italic" data-id="element-39">
                  "Nada de teoría eterna. Pasos. Reglas. Y un sistema que se
                  sostiene aunque estés cansada."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}